import React from 'react';
import clsx from 'clsx';
import { RateCardDiff } from '@/components/tables/cell-renderers/rate-card-diff';

type Props = {
  disabled?: boolean;
  value: string | number | null | undefined;
  diff?: number;
};

export function CalculatedValue({ value, disabled, diff }: Props) {
  return (
    <div
      className={clsx(
        'flex h-full w-full items-center justify-between p-1 px-2',
        disabled && 'opacity-35'
      )}>
      {diff != null && <RateCardDiff change={diff} />}
      <div className="ml-auto text-sm">{value ?? ''}</div>
    </div>
  );
}
